import axios from "axios";
import apiConfig from "../config/apiConfig";

const blogApiInstance = axios.create({
  baseURL: apiConfig.endpoints.blogService.baseURL,
  timeout: 30000,
});

const getBlogPostBySlug = async (slug) => {
  try {
    const encodedSlug = encodeURIComponent(String(slug || "").trim());
    const response = await blogApiInstance.get(`${apiConfig.endpoints.blogService.routes.getPosts}?slug=${encodedSlug}`);
    return {
      data: response.data,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const getAllBlogPosts = async (url) => {
  try {
    const response = await blogApiInstance.get(`${apiConfig.endpoints.blogService.routes.getPosts}${url}`);
    return {
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const getCategorizedBlogPosts = async (categoryId, currentPage) => {
  try {
    const response = await blogApiInstance.get(`${apiConfig.endpoints.blogService.routes.getPosts}?categories=${categoryId}&per_page=4&page=${currentPage}`);
    return {
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const getRelatedBlogPosts = async (categoryId) => {
  try {
    const response = await blogApiInstance.get(`${apiConfig.endpoints.blogService.routes.getPosts}?categories=${categoryId}`);
    return {
      data: response.data,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const postComment = async ({ author_name, author_email, content, post }) => {
  try {
    const response = await blogApiInstance.post(apiConfig.endpoints.blogService.routes.createComment, {
      author_name,
      author_email,
      content,
      post,
    });
    return {
      data: response.data,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const getComments = async (postId) => {
  try {
    const response = await blogApiInstance.get(`${apiConfig.endpoints.blogService.routes.getComments}?post=${postId}`);
    return {
      data: response.data,
    };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const blogApi = {

  getBlogPostBySlug,
  getAllBlogPosts,
  postComment,
  getRelatedBlogPosts,
  getCategorizedBlogPosts,
  getComments,
};

export default blogApi;
